import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Switch } from 'antd';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import TooltipHelp from 'components/Tooltip/tooltipHelp';
import EditorTextoExibir from './exibir';
import { handleOnChange } from './EditorTexto';
import * as S from './styles';
import * as Style from 'components/Style';

export const ComponentEditorTexto = ({
  handleChange = () => {},
  errors,
  label,
  disabled,
  data,
  name,
  tooltipSwitchText,
  visualizarJustificativa = true,
  statusSwitchDefault = false,
}) => {
  const unitaryTests = useSelector(state => state.app.unitaryTests);

  const [mensagemHtml, setMensagemHtml] = useState(data);
  const [exibirHtml, setExibirHtml] = useState(statusSwitchDefault);

  return (
    <S.ContainerEditorTexto>
      <div style={{ display: 'flex' }}>
        {label && <S.Label>{label}</S.Label>}
        {visualizarJustificativa && (
          <>
            <Switch
              checkedChildren="SIM"
              unCheckedChildren="NÃO"
              onChange={statusSwitch => setExibirHtml(statusSwitch)}
              style={{ marginBottom: '10px', marginRight: '10px' }}
            />
            <TooltipHelp text={tooltipSwitchText} />
          </>
        )}
      </div>
      {!unitaryTests && (
        <CKEditor
          data-testid={name}
          name={name}
          disabled={disabled}
          data={data}
          editor={ClassicEditor}
          onChange={(event, editor) => handleOnChange(event, editor, setMensagemHtml, handleChange, name)}
          config={{
            removePlugins: ['EasyImage', 'ImageUpload', 'MediaEmbed'],
          }}
          style={{ minHeight: '130px' }}
        />
      )}
      {errors?.[name] && <Style.GlobalErro>{errors[name]?.message}</Style.GlobalErro>}
      {exibirHtml && <EditorTextoExibir mensagemHtml={mensagemHtml} border />}
      <br />
    </S.ContainerEditorTexto>
  );
};

ComponentEditorTexto.propTypes = {
  handleChange: PropTypes.func,
  errors: PropTypes.object,
  label: PropTypes.string,
  data: PropTypes.string,
  visualizarJustificativa: PropTypes.bool,
  statusSwitchDefault: PropTypes.bool,
};

ComponentEditorTexto.defaultProps = {
  // handleChange: () => {},
  // errors: {},
  // label: '',
  // data: '',
  // visualizarJustificativa: true,
  // statusSwitchDefault: false,
};

export default ComponentEditorTexto;
